import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { ErrorHandler } from './error-handler';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(public authService: AuthService, public router: Router, private errorHandler: ErrorHandler) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (request.url.includes('/login') || request.url.includes('/forgot-password') || request.url.includes('/reset-password')) {
      return next.handle(request);
    }
    
    request = request.clone({
      setHeaders: {
        Authorization: this.authService.getToken()
      }
    });

    // let ok: string;

    return next.handle(request)
    // .do((event: HttpEvent<any>) => {}, (err: any) => {
    //   if (err instanceof HttpErrorResponse) {
    //     this.errorHandler.handleError(err);
    //   }
    // });
    
    .catch((err: HttpErrorResponse) => {
      console.log("ERROR", err);
      if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
      } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
          if (err.status === 401) {
            //this.authService.logout();
            //alert("usuario no autorizado")
          } else if (err.status === 0) {
            console.log(err.message);
          }
          
      }

      return Observable.throw(err);
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/auth/token.interceptor.ts